import { PlaceableTile } from '../config/tiles';
import { ShapeId } from '../config/shapes';

const DAILY_SAVE_KEY = 'lithoform-daily-save';
const DAILY_SCORES_KEY = 'lithoform-daily-scores';

export interface DailySaveData {
  date: string;
  gridSize: number;
  shapeId: ShapeId;
  cells: Array<{ tile: PlaceableTile | null; restored: boolean }>;
  current: PlaceableTile;
  next: PlaceableTile;
  isFirstTile: boolean;
  rngCalls: number;
  score: number;
  streak: number;
  heat: number;
  harmony: number;
  patience: number;
  rhythm: number;
  shields: number;
  lastPlayed: number;
}

interface DailyScores {
  [date: string]: number;
}

export function saveDailyGame(data: DailySaveData): void {
  localStorage.setItem(DAILY_SAVE_KEY, JSON.stringify(data));
}

export function loadDailyGame(): DailySaveData | null {
  const raw = localStorage.getItem(DAILY_SAVE_KEY);
  if (!raw) return null;

  try {
    const data = JSON.parse(raw) as Record<string, unknown>;
    if (
      typeof data.date !== 'string' ||
      typeof data.gridSize !== 'number' ||
      !Array.isArray(data.cells)
    ) {
      return null;
    }
    return data as unknown as DailySaveData;
  } catch {
    return null;
  }
}

export function clearDailySave(): void {
  localStorage.removeItem(DAILY_SAVE_KEY);
}

export function hasDailySave(): boolean {
  return localStorage.getItem(DAILY_SAVE_KEY) !== null;
}

export function getDailyBestScore(date: string): number | null {
  const scores = loadDailyScores();
  return scores[date] ?? null;
}

export function saveDailyBestScore(date: string, score: number): void {
  const scores = loadDailyScores();
  const existing = scores[date] ?? 0;
  if (score > existing) {
    scores[date] = score;
    localStorage.setItem(DAILY_SCORES_KEY, JSON.stringify(scores));
  }
}

export function getAllDailyScores(): DailyScores {
  return loadDailyScores();
}

function loadDailyScores(): DailyScores {
  const raw = localStorage.getItem(DAILY_SCORES_KEY);
  if (!raw) return {};
  try {
    return JSON.parse(raw) as DailyScores;
  } catch {
    return {};
  }
}
